import React, { useContext, useEffect } from 'react';

import { Card, Button } from 'react-bootstrap'
import { CodingEventTable } from '../../../controls/';
import ConditionalRender from '../../../controls/formControls/ConditionalRender';
import { CodingEventQueueContext } from '../../../contexts/CodingEventQueueContext';

const AllEventsQueue = (props) => {

    const filterType = 'codingEvents';

    const context = useContext(CodingEventQueueContext);

    useEffect(() => {
        context.setFilterType(filterType);
    }, []);

    console.log("Rendering AllEventQueue")
    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >{context.editMode ? "Editing Selected Events" : "Coding Events"}</div>
                <div className="card-btn-group">
                    <ConditionalRender visible={context.filtered}>
                        <Button variant="secondary" size="sm" onClick={() => context.resetFilters()}>Clear Filters</Button>
                    </ConditionalRender>
                    <ConditionalRender visible={context.editMode} >
                        <Button variant="secondary" size="sm" onClick={() => context.setEditMode(false)}>Cancel Edit</Button>
                        {/* <Button variant="success" size="sm" onClick={() => this.saveSelected()}>Save Changes</Button>*/}
                    </ConditionalRender>
                    <ConditionalRender visible={context.selectedEvents.length > 0 && context.editMode} >
                        <Button variant="secondary" size="sm" onClick={() => context.clearSelectedEvents()}>Clear Selected</Button>
                        {/*<Button variant="primary" size="sm" onClick={() => this.editSelected(true)}>Edit Selected</Button>*/}
                        <Button variant="primary"
                            size="sm"
                            onClick={() => context.editSelected()}>
                            Edit Selected
                            </Button>
                    </ConditionalRender>
                    <ConditionalRender visible={!context.editMode}>
                        <Button size="sm" onClick={() => context.setEditMode(true)}>Edit</Button>
                    </ConditionalRender>

                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                <CodingEventTable
                    pageSize="30"
                    canBulkEdit
                />
            </Card.Body>
        </Card>
    )
}

export default AllEventsQueue;